'use client';

import { FC } from 'react';
import { ConfirmDeactivateUserDialogProps } from './ConfirmDeactivateUserDialog.types';
import { Alert, Flex, Button, ButtonGroup, Dialog } from '@/_components';

export const ConfirmDeactivateUserDialog: FC<
  ConfirmDeactivateUserDialogProps
> = ({
  isOpen,
  isPrimaryOwnerOfAtLeastOneCompany,
  onClose,
  onToggleDeactivateAccount,
  isLoading,
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Deactivate User">
      <Dialog.Content>
        <Flex isColumn={true} gap={12}>
          <Alert type="danger">
            {isPrimaryOwnerOfAtLeastOneCompany ? (
              <>
                Do you want to only deactivate this user OR deactivate this user
                and all the entities of which it is the <strong>primary</strong>{' '}
                user?
                <br />
                <br />
                No matter your choice, if you deactivate this user, all
                questionnaires will be locked and all scheduled questionnaires
                for this user will be removed.
              </>
            ) : (
              <>
                Are you sure you want to deactivate this user? All
                questionnaires will be locked and all scheduled questionnaires
                for this user will be removed.
              </>
            )}
          </Alert>
          <ButtonGroup align="right">
            <Button
              value="Cancel"
              intent="secondary"
              onClick={onClose}
              isDisabled={isLoading}
            />
            <Button
              value="Deactivate user and its entities"
              intent="danger"
              isDisabled={isLoading}
              onClick={() => onToggleDeactivateAccount(false, true)}
            />
            <Button
              value="Deactivate user"
              intent="danger"
              isDisabled={isLoading}
              onClick={() => onToggleDeactivateAccount(false)}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
